import AppRoutes from "./AppRoutes";

function App() {
  return (
    <div className="container">
      <AppRoutes />
    </div>
  );
}

export default App;
